// convenience util for spotting indicators of failed login attempts
const isFailedLogin = (request, response) =>
  response?.status === 401 && request?.url?.includes?.('/login');

// filter out failed login attempts
export function loginFailures(event, hint) {
  const { request, response } = hint?.originalException || {};
  return !(
    event?.extra?.message?.startsWith?.('Failed to authenticate user') ||
    isFailedLogin(request, response)
  );
}
